import { useRef, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, ScanLine, Upload } from 'lucide-react';

export function UploadCard({ onUpload, uploading }) {
  const fileRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const pick = (file) => { if (file) onUpload(file); };

  return (
    <Card
      className={`border-dashed border-2 transition-colors ${drag ? 'border-[#2d948c] bg-[#2d948c]/5' : 'border-[#2d948c]/30'}`}
      onDragOver={e => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={e => {
        e.preventDefault();
        setDrag(false);
        pick(e.dataTransfer.files?.[0]);
      }}
    >
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <ScanLine className="h-12 w-12 text-[#2d948c] mb-4" />
        <h2 className="font-heading text-xl font-semibold text-[#1f2933]">Process a receipt</h2>
        <p className="text-sm text-[#5b6773] mt-2 max-w-md">
          Upload a photo or PDF of any receipt. We'll read it with AI and give you an editable
          line-item table next to the original so you can verify and correct anything before saving.
        </p>
        <input
          ref={fileRef}
          type="file"
          accept="image/*,application/pdf"
          className="hidden"
          onChange={e => pick(e.target.files?.[0])}
          data-testid="process-receipt-file-input"
        />
        <Button
          className="mt-6 gap-2"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          data-testid="process-receipt-upload-btn"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {uploading ? 'Reading receipt…' : 'Choose file'}
        </Button>
        <p className="text-[11px] text-[#5b6773]/80 mt-3">JPG · PNG · WEBP · PDF (up to 6 pages)</p>
      </CardContent>
    </Card>
  );
}
